import { render, staticRenderFns } from "./datika.vue?vue&type=template&id=4a3fa260&scoped=true&"
import script from "./datika.vue?vue&type=script&lang=js&"
export * from "./datika.vue?vue&type=script&lang=js&"
import style0 from "./datika.vue?vue&type=style&index=0&id=4a3fa260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3fa260",
  null
  
)

export default component.exports